export const CityNamesIcon = ({
  color = "#475569",
}: {
  color?: string;
}) => {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 3.375H4.5V4.125H5.25V3.375ZM6 3.375H6.75V4.125H6V3.375ZM8.25 3.375H7.5V4.125H8.25V3.375ZM4.5 4.875H5.25V5.625H4.5V4.875ZM6.75 4.875H6V5.625H6.75V4.875ZM7.5 4.875H8.25V5.625H7.5V4.875ZM5.25 6.375H4.5V7.125H5.25V6.375ZM6 6.375H6.75V7.125H6V6.375ZM8.25 6.375H7.5V7.125H8.25V6.375ZM4.5 7.875H5.25V8.625H4.5V7.875ZM6.75 7.875H6V8.625H6.75V7.875ZM4.5 9.375H5.25V10.125H4.5V9.375ZM6.75 9.375H6V10.125H6.75V9.375ZM4.5 10.875H5.25V11.625H4.5V10.875ZM6.75 10.875H6V11.625H6.75V10.875ZM4.5 12.375H5.25V13.125H4.5V12.375ZM6.75 12.375H6V13.125H6.75V12.375ZM8.625 9.75H9.75V9H8.625V9.75ZM9.75 11.25H8.625V10.5H9.75V11.25ZM8.625 12.75H9.75V12H8.625V12.75Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.375 0L9.375 2.25V7.5H10.875C10.9745 7.5 11.0698 7.53951 11.1402 7.60983C11.2105 7.68016 11.25 7.77554 11.25 7.875V14.25H11.625C11.7245 14.25 11.8198 14.2895 11.8902 14.3598C11.9605 14.4302 12 14.5255 12 14.625C12 14.7245 11.9605 14.8198 11.8902 14.8902C11.8198 14.9605 11.7245 15 11.625 15H0.375C0.275544 15 0.180161 14.9605 0.109835 14.8902C0.0395089 14.8198 0 14.7245 0 14.625C0 14.5255 0.0395089 14.4302 0.109835 14.3598C0.180161 14.2895 0.275544 14.25 0.375 14.25H0.75V6.375C0.75 6.27554 0.789509 6.18016 0.859835 6.10983C0.930161 6.03951 1.02554 6 1.125 6H1.875V3.375H2.625V6H3.375V0ZM4.125 1.08225L8.625 2.76975V7.5H7.5C7.40054 7.5 7.30516 7.53951 7.23483 7.60983C7.16451 7.68016 7.125 7.77554 7.125 7.875V14.25H4.125V1.08225ZM1.5 6.75V14.25H3.375V6.75H1.5ZM10.5 14.25H9.75V13.5H8.625V14.25H7.875V8.25H10.5V14.25Z"
        fill={color}
      />
    </svg>
  );
};
